<template>
    <div class="vx-card p-6" id="info-customer">
        <div class="vx-row">
            <div class="vx-col xl:w-2/3 md:w-1/2 w-full">
                <!-- Col Header -->
                <div class="flex items-end mb-3">
                    <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-6 h-6"/>
                    <span class="leading-none font-medium fsz">{{ $t('menuCustomer.contactInfo') }}</span>
                </div>
                <div class="vx-row">
                    <div class="vx-col xl:w-1/2 md:w-full w-full mt-4">
                        <label class="vs-input--label required">Chi nhánh</label>
                        <v-select class="w-full" v-model="customerInfo.organizationBranchId"
                                  :options="organizationBranchOptions" :reduce="item => item.value"
                                  name="branch" v-validate="'required'"></v-select>
                        <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
                    </div>
                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-4">
                        <label class="vs-input--label">Nguồn KH</label>
                        <v-select class="w-full" v-model="customerInfo.source" :options="sourceOptions" 
                                  v-validate="''" :reduce="item => item.value"></v-select>
                    </div>
                    <!--                    <div class="vx-col xl:w-1/4 w-1/2 mt-4">-->
                    <!--                        <label class="vs-input&#45;&#45;label required">Họ</label>-->
                    <!--                        <vs-input class="w-full" v-model="firstNameModel" v-validate="'required'" name="firstName"/>-->
                    <!--                        <span class="text-danger text-sm">{{ errors.first('firstName') }}</span>-->
                    <!--                    </div>-->

                    <!--                    <div class="vx-col xl:w-1/4 w-1/2 mt-4">-->
                    <!--                        <label class="vs-input&#45;&#45;label required">Tên</label>-->
                    <!--                        <vs-input class="w-full" v-model="lastNameModel" v-validate="'required'" name="lastName"/>-->
                    <!--                        <span class="text-danger text-sm">{{ errors.first('lastName') }}</span>-->
                    <!--                    </div>-->

                    <!--                    <div class="vx-col xl:w-1/2 w-full mt-4">-->
                    <!--                        <label class="vs-input&#45;&#45;label required">{{ $t('menuCustomer.customerName') }}</label>-->
                    <!--                        <vs-input class="w-full" v-model="fullNameModel" v-validate="'required'" name="fullName"-->
                    <!--                                  disabled/>-->
                    <!--                        <span class="text-danger text-sm">{{ errors.first('fullName') }}</span>-->
                    <!--                    </div>-->
                    <div class="vx-col xl:w-1/3 w-full mt-4">
                        <label class="vs-input--label required">{{
                                $t('menuCustomer.customerName')
                            }}</label>
                        <vs-input class="w-full" v-model="customerInfo.fullName" 
                                  name="fullName"  v-validate="'required'"/>
                        <span class="text-danger text-sm">{{ errors.first('fullName') }}</span>
                    </div>

                    <div class="vx-col xl:w-1/4 sm:w-1/2 w-full mt-4">
                        <label class="vs-input--label">{{ $t('menuCustomer.dayOfBirth') }}</label>
                        <flat-pickr :config="configDatePicker" v-model="customerInfo.birthday"
                                    class="w-full vs-inputx vs-input--input normal" v-validate="''"
                                    name="dayOfBirth"/>
                        <span class="text-danger text-sm">{{ errors.first('dayOfBirth') }}</span>
                    </div>

                    <div class="vx-col xl:w-1/4 sm:w-1/2 w-full mt-4">
                        <label class="vs-input--label">{{ $t('menuCustomer.identityCard') }}</label>
                        <vs-input class="w-full" v-model="customerInfo.passport"
                                  v-validate="'numeric|min:9|max:12'" name="identityCard"/>
                        <span class="text-danger text-sm">{{ errors.first('identityCard') }}</span>
                    </div>
                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-4">
                        <label class="vs-input--label required">{{ $t('menuCustomer.gender') }}</label>
                        <v-select class="w-full" v-model="customerInfo.gender" :options="genderOptions" name="gender"
                                   :reduce="item => item.value"   v-validate="'required'"></v-select>
                        <span class="text-danger text-sm">{{ errors.first('gender') }}</span>
                    </div>

                    <div class="vx-col xl:w-1/4 sm:w-1/2 w-full mt-4">
                        <label class="vs-input--label">{{ $t('menuCustomer.weight') }}</label>
                        <vs-input class="w-full" v-model="customerInfo.weight" v-validate="'decimal:2'" name="weight"/>
                        <!-- <span class="text-danger text-sm">{{ errors.first('weight') }}</span> -->
                    </div>

                    <div class="vx-col xl:w-1/4 sm:w-1/2 w-full mt-4">
                        <label class="vs-input--label">{{ $t('menuCustomer.job') }}</label>
                        <vs-input class="w-full" v-model="customerInfo.job" name="job"/>
                    </div>
                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-4">
                        <label class="vs-input--label">{{ $t('menuCustomer.email') }}</label>
                        <vs-input class="w-full" v-model="customerInfo.email" v-validate="'email'"
                                  name="email"/>
                        <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                    </div>
                    <div class="vx-col xl:w-1/4 sm:w-1/2 w-full mt-4">
                        <label class="vs-input--label">{{ $t('menuCustomer.ethnic') }}</label>
                        <vs-input class="w-full" v-model="customerInfo.ethnic" name="ethnic"/>
                        <span class="text-danger text-sm">{{ errors.first('ethnic') }}</span>
                    </div>
                    <div class="vx-col xl:w-1/4 sm:w-1/2 w-full mt-4">
                        <label class="vs-input--label required">{{ $t('menuCustomer.phoneNumber') }}</label>
                        <vs-input class="w-full" v-model="customerInfo.phoneNumber"
                                  v-validate="'required|phone_rule|max:10|min:10|numeric'"
                                  name="phoneNumber"/>
                        <span class="text-danger text-sm">{{ errors.first('phoneNumber') }}</span>
                    </div>
              
                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-4">
                        <label class="vs-input--label">Nguồn</label>
                        <v-select class="w-full" v-model="customerInfo.sourcePlatform" :options="sourcePlatformOptions" 
                                  v-validate="''" :reduce="item => item.value"></v-select>
                    </div>
                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-4">
                        <label class="vs-input--label">{{ $t('menuCustomer.nickName') }}</label>
                        <vs-input class="w-full" v-model="customerInfo.nickName" v-validate=""
                                  name="nickName"/>
                        <span class="text-danger text-sm">{{ errors.first('nickName') }}</span>
                    </div>
                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-4">
                        <label class="vs-input--label">Phương thức</label>
                        <v-select class="w-full" v-model="customerInfo.interactionType" :options="interactionTypeOptions" 
                                  v-validate="''" :reduce="item => item.value"></v-select>
                    </div>
                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-4">
                        <label class="vs-input--label">Nhân viên tư vấn</label>
                        <vs-input class="w-full" v-model="customerInfo.referenceEmployee" 
                                  />
                    </div>
                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-4">
                        <label class="vs-input--label">Nhân viên giới thiệu</label>
                        <vs-input class="w-full"  v-model="customerInfo.referralEmployee" 
                                  />
                    </div>
                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-6 flex items-center">
                        <vs-checkbox v-model="partnerType">{{ $t('menuCustomer.partnerType') }}</vs-checkbox>
                    </div>
                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-4" v-if="showSelectedSourceType">
                        <label class="vs-input--label">{{ $t('menuCustomer.sourceType') }}</label>
                        <v-select class="w-full" v-model="customerInfo.sourceType" :options="sourceTypeOptions"
                                  name="sourceType"
                                  v-validate="''" :reduce="item => item.value" :disabled="isUpdate"></v-select>
                        <span class="text-danger text-sm">{{ errors.first('sourceType') }}</span>
                    </div>
                    <div class="vx-col w-full mt-4">
                        <label class="vs-input--label">Ghi chú</label>
                        <vs-textarea class="w-full" v-model="customerInfo.note"/>
                    </div>
                </div>

                <vs-divider class="mt-8"/>

                <!-- Col Header -->
                <div class="vx-col w-full mt-2 mb-3">
                    <feather-icon icon="MapPinIcon" class="mr-2" svgClasses="w-6 h-6"/>
                    <span class="leading-none font-medium fsz">{{ $t('menuCustomer.address') }}</span>
                </div>
                <div class="vx-row">
                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-2">
                        <label class="vs-input--label">{{ $t('menuCustomer.city') }}</label>
                        <v-select class="w-full" v-model="province" :clearable="false" :options="cityOptions"
                                  name="city"
                                  v-validate="''">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('city') }}</span>
                    </div>
                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-2">
                        <label class="vs-input--label">{{ $t('menuCustomer.district') }}</label>
                        <v-select class="" v-model="district" :clearable="false" :options="districtOptions"
                                  name="district"
                                  v-validate="''">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('district') }}</span>
                    </div>

                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-2">
                        <label class="vs-input--label">{{ $t('menuCustomer.commune') }}</label>
                        <v-select class="" v-model="subDistrict" :clearable="false" :options="subDistrictOptions"
                                  name="subDistrict"
                                  v-validate="''">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('subDistrict') }}</span>
                    </div>
                    <div class="vx-col xl:w-1/3 sm:w-1/2 w-full mt-2">
                        <label class="vs-input--label">{{ $t('menuCustomer.houseNumber') }}</label>
                        <vs-input class="w-full" v-model="customerInfo.houseNumber" name="houseNumber"
                                  v-validate="''"/>
                        <span class="text-danger text-sm">{{ errors.first('houseNumber') }}</span>
                    </div>
                    <div class="vx-col xl:w-2/3 w-full mt-2">
                        <label class="vs-input--label">{{ $t('menuCustomer.address') }}</label>
                        <vs-input class="w-full" v-model="fullAddressModel" name="full_address" readonly/>
                    </div>
                </div>
            </div>
            <div class="vx-col xl:w-1/3 md:w-1/2 w-full">
                <div class="vx-col w-full md:mt-0 mt-6">
                    <!-- Col Header -->
                    <div class="flex justify-center mb-3">
                        <feather-icon icon="MaximizeIcon" class="mr-2" svgClasses="w-6 h-6"/>
                        <span class="leading-none font-medium fsz mt-1">{{ $t('menuCustomer.faceData') }}</span>
                    </div>
                    <div class="vx-row">
                        <vue-upload-multiple-image class="m-auto" @upload-success="uploadImageSuccess"
                                                   @before-remove="beforeRemove" @edit-image="editImage"
                                                   @data-change="dataChange"
                                                   :data-images="images">
                        </vue-upload-multiple-image>
                    </div>
                </div>
                <div class="vx-col w-full md:mt-32 mt-6" v-if="customerInfo.card">
                    <!-- Col Header -->
                    <div class="flex justify-center mb-3">
                        <vs-icon icon="credit_card" size="small mr-2"></vs-icon>
                        <span class="leading-none font-medium fsz mt-1">Thẻ thành viên</span>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-full flex justify-center">
                            <div class="flex justify-center items-center">
                                <div class="flip-card">
                                    <div class="flip-card-inner">
                                        <div class="flip-card-front items-center"
                                             :style="{'background': 'url(' + customerInfo.urlImageCard + ')'}">
                                            <div class="p-8 h-full w-full align-middle">
                                                <div class="vx-row">
                                                    <div class="vx-col w-full">
                                        <span class="text-xl text-primary font-bold">{{
                                                customerInfo.cardNumber
                                            }}</span>
                                                    </div>
                                                </div>
                                                <div class="vx-row mt-2">
                                                    <div class="vx-col w-1/2">
                                                        <span>Ngày tạo:</span>
                                                    </div>
                                                    <div class="vx-col w-1/2">
                                                                        <span class="float-right">{{
                                                                                customerInfo.createdDateFormat
                                                                            }}</span>
                                                    </div>
                                                </div>
                                                <div class="vx-row mt-2">
                                                    <div class="vx-col w-1/2">
                                                        <span>Điểm thưởng:</span>
                                                    </div>
                                                    <div class="vx-col w-1/2">
                                                                        <span class="float-right">{{
                                                                                customerInfo.points
                                                                            }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="flip-card-back items-center"
                                             :style="{'background': 'url(' + customerInfo.urlImageCard + ')'}">
                                            <div
                                                class="p-8 h-full w-full flex items-center justify-center">
                                                                <span class="font-bold text-primary">{{
                                                                        customerInfo.nameRankCard
                                                                    }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm"
                               v-if="isPermissionUpdate && !isRead">{{ `${isUpdate ? $t('button.update') : $t('button.create')}` }}
                    </vs-button>
                    <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.push('/user/customer')"
                               v-if="!loyaltyCustomerId && !isProp && !isRead">
                        {{ $t('button.back') }}
                    </vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import VueUploadMultipleImage from '../../../../components/VueUploadMultipleImage';
import province from '../../../../assets/utils/province.js';
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import {en, vi} from "vuejs-datepicker/dist/locale";
import moment from "moment";
// import country from '../../../assets/utils/country';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Vietnamese} from 'flatpickr/dist/l10n/vn';
import {isAPI} from "../../../../store/permission";
import {constAPI} from "../../../../store/constant";

export default {
    components: {
        VueUploadMultipleImage,
        vSelect,
        Datepicker,
        flatPickr,
    },
    props: {
        loyaltyCustomerId: {
            default: null,
            type: Number,
        },
        phoneNumber: {
            default: null,
            type: String,
        },
        isProp: {
            default: false,
            type: Boolean,
        },
        isRead: {
            default: false,
            type: Boolean,
        },
    },
    data() {
        return {
            organizationBranchOptions: [],
            cityOptions: province.getProvince(),
            // countryOptions: country.getCountry(),
            districtOptions: [],
            subDistrictOptions: [],
            isUpdate: false,
            customerInfo: {
                id: null,
                code: null,
                fullName: null,
                phoneNumber: null,
                city: null,
                district: null,
                fullAddress: null,
                houseNumber: null,
                birthday: null,
                gender: null,
                email: null,
                ethnic: null,
                job: null,
                country: "Việt Nam",
                firstName: null,
                lastName: null,
                organizationBranchId: null,
                passport: null,
                street: null,
                weight: null,
                sourceType: null,
                sourcePlatform:null,
                source:null,
                interactionType:null,
                referenceEmployee:'',
                referralEmployee:'',
            },
            sourcePlatformOptions:[{value:1,label:'Facebook'},
            {value:2,label:'Zalo'},
            {value:3,label:'Website'},
            {value:4,label:'Tiktok'}
            ],
            sourceOptions:[          
                { value: 1, label: 'Phòng kinh doanh 1' },
                { value: 2, label: 'Phòng kinh doanh 2' },
                { value: 3, label: 'Nhân viên' },
                { value: 4, label: 'Phòng kinh doanh 3' },
                { value: 5, label: 'Phòng kinh doanh 4' },
                { value: 6, label: 'Nguồn khác' },
                { value: 7, label: 'Nguồn App' },
            ],
            interactionTypeOptions:[{value:1,label:'Trực tiếp với nhân viên'}],
            images: [],
            user_data: null,
            imagesId: [],
            highlighted: {
                dates: [
                    new Date()
                ]
            },
            disabledFn: {
                customPredictor(date) {
                    if (moment(date).isAfter(moment(), 'days')) {
                        return true;
                    }
                }
            },
            en: en,
            vi: vi,
            genderOptions: [
                {value: 0, label: this.$t('genderOption.unknown')},
                {value: 1, label: this.$t('genderOption.male')},
                {value: 2, label: this.$t('genderOption.female')}
            ],
            customerId: null,
            isCustomerPancake:null,
            configDatePicker: {
                dateFormat: 'Z',
                // defaultDate: new Date(),
                locale: Vietnamese,
                maxDate: new Date(),
                altFormat: 'd/m/Y',
                altInput: true,
                wrap: true,
                allowInput: true,
            },
            typeCustomer: [
                {value: 1, label: 'Khách hàng chính thức'},
                {value: 2, label: 'Khách hàng tiềm năng'},
            ],
            sourceTypeOptions: [
                {value: 2, label: 'Nguồn phòng ban'},
                {value: 3, label: 'Nguồn cá nhân'},
            ],
            userInfo: null,
            departmentData: [],
            showSelectedSourceType: false,
            employeeInfo: null,
            autoCreateMedicalRecordCheck: false,
            partnerType: false,
        }
    },
    async created() {
        console.log(this.loyaltyCustomerId)

        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        if (branchList.length === 0) {
            return this.$vs.notify({
                text: this.$t('menuOrganization.noBranch'),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        }
        this.organizationBranchOptions = branchList.map(item => {
            return {value: item.id, label: item.organizationBranchName}
        });
        this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        this.customerInfo.organizationId = this.userInfo.organization.id;
        if (!this.isUpdate) await this.getDepartment();

        await this.checkSourceType();
        this.customerId = this.loyaltyCustomerId ? this.loyaltyCustomerId : this.$route.query.id;
        this.isCustomerPancake = this.$route.query.isCustomerPancake
        if (this.customerId) {
            this.isUpdate = true;
            await this.findById();
            for (const x of this.customerInfo.fileManagers) {
                let data = await this.toDataURL(x.url);
                let dataImage = data.xhr.response;
                let metadata = {
                    type: 'image/jpeg'
                };
                let file = new File([dataImage], x.fileName, metadata);
                this.images.push({
                    name: x.fileName,
                    path: data.imgBase64,
                    highlight: 1,
                    default: 1,
                    file: file,
                    type: 1,
                });
            }
        }

        if (this.phoneNumber) this.customerInfo.phoneNumber = this.phoneNumber

        let imageUrl = this.$route.query.imageUrl
        if (imageUrl) {
            this.customerInfo.imageUrl = imageUrl;
            let data = await this.toDataURL(this.customerInfo.imageUrl);
            let dataImage = data.xhr.response;
            let metadata = {
                type: 'image/jpeg'
            };
            let file = new File([dataImage], "avatar", metadata);
            this.images.push({
                name: "avatar",
                path: data.imgBase64,
                highlight: 1,
                default: 1,
                file: file,
                type: 1,
            });
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any()
        },
        firstNameModel: {
            get() {
                return this.customerInfo.firstName;
            },
            set(value) {
                this.customerInfo.firstName = value;
            }
        },
        lastNameModel: {
            get() {
                return this.customerInfo.lastName;
            },
            set(value) {
                this.customerInfo.lastName = value;
            }
        },
        fullNameModel: {
            get() {
                let fullName = `${this.firstNameModel ? this.firstNameModel + ' ' : ''}${this.lastNameModel ? this.lastNameModel + ' ' : ''}`;
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.customerInfo.fullName = fullName;
                return fullName;
            },
        },
        // country: {
        //     get() {
        //         return {
        //             label: this.getLabelString(this.countryOptions.find(x => x.label === this.customerInfo.country)),
        //             value: this.customerInfo.country
        //         }
        //     },
        //     set(obj) {
        //         this.customerInfo.country = obj ? obj.label : null;
        //     }
        // },
        province: {
            get() {
                return {
                    label: this.getLabelString(this.cityOptions.find(x => x.value === this.customerInfo.city)),
                    value: this.customerInfo.city
                }
            },
            set(obj) {
                if (obj.value) {
                    this.customerInfo.city = obj.value;
                    this.districtOptions = province.getDistrict(obj.value);
                    this.customerInfo.district = this.districtOptions[0].value;
                    this.subDistrictOptions = province.getSubDistrict(this.customerInfo.city, this.customerInfo.district);
                    this.customerInfo.street = this.subDistrictOptions[0].value;
                } else {
                    this.customerInfo.city = null;
                    this.districtOptions = [{value: null, label: this.$t('menuCustomer.all')}];
                    this.customerInfo.district = null;
                    this.subDistrictOptions = [{value: null, label: this.$t('menuCustomer.all')}];
                    this.customerInfo.street = null;
                }
            }
        },
        district: {
            get() {
                return {
                    label: this.getLabelString(this.districtOptions.find(x => x.value === this.customerInfo.district)),
                    value: this.customerInfo.district
                }
            },
            set(obj) {
                this.customerInfo.district = obj.value;
                this.subDistrictOptions = province.getSubDistrict(this.customerInfo.city, obj.value);
                this.customerInfo.street = this.subDistrictOptions[0].value;
            }
        },
        subDistrict: {
            get() {
                return {
                    label: this.getLabelString(this.subDistrictOptions.find(x => x.value === this.customerInfo.street)),
                    value: this.customerInfo.street
                }
            },
            set(obj) {
                this.customerInfo.street = obj.value
            }
        },
        fullAddressModel: {
            get() {
                if (this.province.value) {
                    let fullAddress = `${this.customerInfo.houseNumber ? this.customerInfo.houseNumber + ', ' : ''}${this.subDistrict.label ? this.subDistrict.label + ', ' : ''}${this.district.label}, ${this.province.label}`;
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.customerInfo.fullAddress = fullAddress;
                    return fullAddress;
                } else if (!this.province.value && this.isUpdate) {
                    return this.customerInfo.fullAddress;
                } else {
                    return null;
                }
            },
        },
    },

    methods: {
        toDataURL(url) {
            return new Promise(resolve => {
                let xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    let reader = new FileReader();
                    reader.onloadend = function () {
                        resolve({imgBase64: reader.result, xhr: xhr});
                    }
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();
            })
        },
        findById() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                let url = this.isCustomerPancake == 'true'  ? `/loyalty/potential-customer/find-by-id/${this.customerId}` : `/loyalty/customer/find-by-id?id=${this.customerId}`   
                this.$crm.post(url).then((response) => {
                    this.customerInfo = response.data;
                        if(this.isCustomerPancake == 'true'){
                        console.log('kkk',response)
                        this.customerInfo.organizationBranchId = response.data.department.organizationBranchId
                        this.customerInfo.referenceEmployee = response.data.employeeName
                    }
                    this.partnerType = !!this.customerInfo.partnerType
                    if (this.customerInfo.card) {
                        this.customerInfo.urlImageCard = this.customerInfo.card.settingOrganizationCards[this.customerInfo.card.currentCardRankIndex].cardImageUrl;
                        this.customerInfo.nameRankCard = this.customerInfo.card.settingOrganizationCards[this.customerInfo.card.currentCardRankIndex].name;
                    }
                    if (!response.data.firstName && !response.data.lastName) {
                        this.customerInfo.lastName = response.data.fullName;
                    }
                    // this.customerInfo.cardId = response.data.cardId;
                    this.customerInfo.createdDateFormat = moment(response.data.createdDate).format('DD/MM/YYYY');
                    this.customerInfo.cardNumber = response.data.card ? response.data.card.number.toString().replace(/(.{4})/g, "$1  ") : null;
                    this.customerInfo.points = response.data.card ? response.data.card.points : null;
                    this.customerInfo.fullNameUpperCase = response.data.fullName.toString().replace(/(.{1})/g, "$1 ").toUpperCase()
                    // this.countryOptions = country.getCountry(this.customerInfo.country);
                    this.districtOptions = province.getDistrict(this.customerInfo.city);
                    this.subDistrictOptions = province.getSubDistrict(this.customerInfo.city, this.customerInfo.district);
                    this.isUpdate = true;
                    this.$vs.loading.close();
                    resolve(true);
                }).catch((err) => {
                    reject(false);
                    this.$vs.loading.close();
                    this.$vs.notify({
                        title: 'Error',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
        uploadImageSuccess(formData, index, fileList, file) {
            this.images = fileList.map(x => {
                x.type = x.type ? x.type : 0;
                return x;
            });
            // this.customerInfo.urlImage = fileList.length > 0 ? fileList[0].path : null;
            this.setIsUpdateImages();
        },
        beforeRemove(index, done, fileList) {
            this.images = fileList
            this.setIsUpdateImages();
            done();
        },
        editImage(formData, index, fileList) {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        dataChange(data) {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        setIsUpdateImages() {
            if (this.isUpdate) {
                this.isUpdateImages = true;
            }
        },
        getLabelString(object) {
            return (object && object.label) || this.$t('menuCustomer.undefined');
        },

        async saveChanges(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            const formData = new FormData();
            if (this.isUpdate) {
                formData.append('id', this.customerId);
                let newImages = this.images.filter(x => x.type === 0);
                if (newImages && newImages.length > 0) {
                    newImages.forEach(x => formData.append('newImages', x.file));
                    this.images = this.images.filter(x => x.type === 1);
                    this.images.forEach(x => formData.append('images', x.file));
                } else {
                    this.images.forEach(x => formData.append('images', x.file));
                }
            } else {
                this.customerInfo.autoCreateMedicalRecord = this.autoCreateMedicalRecordCheck;
                if (this.images.length > 0) this.images.forEach(x => formData.append('images', x.file));
            }

            this.customerInfo.partnerType = this.partnerType ? 1 : 0

            const blob = new Blob([JSON.stringify(this.customerInfo)], {type: 'application/json'});
            formData.append('loyaltyCustomerDTO ', blob);

            let url = this.isUpdate ? `/loyalty/customer/update` : `/loyalty/customer/create`;
            this.$vs.loading();
            this.$crm.post(url, formData).then(() => {
                this.$vs.notify({
                    color: 'success',
                    text: `${this.isUpdate ? this.$t('menuCustomer.updateCustomerSS') : this.$t('menuCustomer.addCustomerSS')}`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                if (!this.loyaltyCustomerId && !this.isProp) this.$router.push('/user/customer');
                if (this.isProp) this.$eventBus.$emit('popup-add-customer', true);
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        handleClickUploadFile() {
            return new Promise((resolve, reject) => {
                let formData = new FormData(), config;
                this.images.forEach((f, i) => {
                    formData.append('files', f.file);
                });
                config = {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                };
                this.$vs.loading();
                this.$crm.post('/employee/image/upload', formData, config).then((res) => {
                    this.imagesId = [];
                    this.imagesId = res.data;
                    this.$vs.loading.close();
                    resolve(true);
                }).catch((err) => {
                    reject(true);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        isPermissionUpdate() {
            return isAPI(this, constAPI.customer_loyaly_update);
        },

        getDepartment() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();

                this.$crm.post('/department/find-by-condition', {organizationBranchId: this.userInfo.organizationBranchId}).then(res => {
                    this.departmentData = res.data;
                    this.$vs.loading.close();
                    resolve();
                }).catch((err) => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Error',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        getEmployeeData(employeeId) {
            return new Promise((resolve, reject) => {
                this.$vs.loading();

                this.$crm.post(`/employee/find-by-id/${employeeId}`).then(res => {
                    this.employeeInfo = res.data;
                    resolve();
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Error',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        async checkSourceType() {
            if (this.userInfo.userRole === 'user') {

                await this.getEmployeeData(this.userInfo.employeeId);
                let department = this.departmentData.find(el => this.employeeInfo.departmentDTO && el.id === this.employeeInfo.departmentDTO.id);
                if (department && (department.type === 1 || department.type === 2)) {
                    this.showSelectedSourceType = true;
                } else {
                    this.showSelectedSourceType = false;
                    this.customerInfo.sourceType = 3;
                }
            } else {
                this.showSelectedSourceType = false;
                this.customerInfo.sourceType = 4;
            }
        },
    },
}
</script>

<style scoped>
.required:after {
    content: " *";
    color: red;
}

</style>

<style lang="scss">
#info-customer {
    .vs-textarea {
        height: 200px;
    }

    .flip-card {
        background-color: transparent;
        width: 300px;
        height: 150px;
        perspective: 1000px;
        font-family: sans-serif;
    }

    .title {
        font-size: 1.5em;
        font-weight: 900;
        text-align: center;
        margin: 0;
    }

    .flip-card-inner {
        position: relative;
        width: 100%;
        height: 100%;
        text-align: center;
        transition: transform 0.8s;
        transform-style: preserve-3d;
    }

    .flip-card:hover .flip-card-inner {
        transform: rotateY(180deg);
    }

    .flip-card-front, .flip-card-back {
        box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.2);
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        height: 100%;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        border-radius: 1rem;
    }

    .flip-card-back {
        transform: rotateY(180deg);
    }
}
</style>
